export enum PayoutDisputeStatusDetails {
  DisputePaymentTimeout = 'payment_timeout',
  DisputeInvalidRequisites = 'invalid_requisites',
  DisputePaymentFailed = 'payment_failed',
  DisputeRevertCancelled = 'revert_cancelled',
  DisputeVerify = 'dispute_verify',
  DisputeAdminCreated = 'admin_created',
  DisputeCascadeAssigneeTimeout = 'cascade_assignee_timeout',
  DisputeCascadeTotalTimeout = 'cascade_total_timeout',
  DisputeUnresolvedResponse = 'unresolved_response',
}

export enum PayoutRejectStatusDetails {
  RejectNoFunds = 'no_funds',
  RejectRequisitesBlocked = 'requisites_blocked',
  RejectPaymentImpossible = 'payment_impossible',
}

export enum PayoutCancelStatusDetails {
  CancelledByShop = 'shop',
  CancelledByAdmin = 'admin',
  CancelledRequisitesTimeout = 'requisites_timeout',
  CancelledMaxRejectsExceeded = 'max_rejects_exceeded',
  CancelledByOperator = 'operator',
}

export enum PayoutCompleteStatusDetails {
  CompletedHold = 'hold',
}

export const PayoutOrderStatusDetails = {
  ...PayoutDisputeStatusDetails,
  ...PayoutCancelStatusDetails,
  ...PayoutRejectStatusDetails,
  ...PayoutCompleteStatusDetails,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PayoutOrderStatusDetails =
  | PayoutDisputeStatusDetails
  | PayoutCancelStatusDetails
  | PayoutRejectStatusDetails
  | PayoutCompleteStatusDetails;
